webpackJsonp([66833902341220],{

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = exports.default = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Row = __webpack_require__(3);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Column = __webpack_require__(4);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	var _reactHelmet = __webpack_require__(6);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Hero = __webpack_require__(9);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdvisoryCouncil = function (_React$Component) {
	    _inherits(AdvisoryCouncil, _React$Component);
	
	    function AdvisoryCouncil() {
	        _classCallCheck(this, AdvisoryCouncil);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    AdvisoryCouncil.prototype.sort = function sort() {
	        return this.props.data.allContentfulAdvisoryCouncil.edges.sort(function compare(a, b) {
	            var dateA = new Date(a.node.updatedAt);
	            var dateB = new Date(b.node.updatedAt);
	            return dateA - dateB;
	        });
	    };
	
	    AdvisoryCouncil.prototype.render = function render() {
	        // console.log('this.props ======> ',this.props)
	        var sortedArray = this.sort();
	        // console.log('THE SORTED ARRAY === ', sortedArray)
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_reactHelmet2.default, { title: 'Advisory Council | Global Citizen Year' }),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_Hero2.default, { title: 'Advisory Council' })
	            ),
	            _react2.default.createElement(
	                _Row2.default,
	                { className: 'capper' },
	                sortedArray.map(function (member, index) {
	                    if (member.node.emeritusBoard !== true) {
	                        return _react2.default.createElement(
	                            _Column2.default,
	                            { key: index, width: '4', tablet: '6', mobile: '12' },
	                            _react2.default.createElement(
	                                'div',
	                                { style: { padding: '20px' } },
	                                _react2.default.createElement(
	                                    'h2',
	                                    { style: { marginBottom: '10px' } },
	                                    member.node.name
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    member.node.additionalDetails.additionalDetails
	                                )
	                            )
	                        );
	                    }
	                })
	            ),
	            _react2.default.createElement(
	                _Row2.default,
	                { className: 'no-top-padding capper' },
	                _react2.default.createElement(
	                    _Column2.default,
	                    { width: '12' },
	                    _react2.default.createElement(
	                        'h2',
	                        { className: 'h2', style: { textAlign: 'center' } },
	                        'Emeritus Board'
	                    ),
	                    _react2.default.createElement('hr', { style: { margin: '20px auto', height: '1px', background: '#ededed' } })
	                ),
	                this.props.data.allContentfulAdvisoryCouncil.edges.map(function (member, index) {
	                    return member.node.emeritusBoard && _react2.default.createElement(
	                        _Column2.default,
	                        { key: index, width: '4', tablet: '6', mobile: '12' },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { padding: '20px' } },
	                            _react2.default.createElement(
	                                'h2',
	                                { style: { marginBottom: '10px' } },
	                                member.node.name
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                member.node.additionalDetails.additionalDetails
	                            )
	                        )
	                    );
	                })
	            )
	        );
	    };
	
	    return AdvisoryCouncil;
	}(_react2.default.Component);
	
	exports.default = AdvisoryCouncil;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-advisory-council-js-9629356e48d689e69ff8.js